"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldLengths;
(function (FieldLengths) {
    FieldLengths[FieldLengths["FIRST_NAME"] = 40] = "FIRST_NAME";
    FieldLengths[FieldLengths["LAST_NAME"] = 80] = "LAST_NAME";
    FieldLengths[FieldLengths["EMAIL"] = 80] = "EMAIL";
    FieldLengths[FieldLengths["NUMBER_OF_MEMBERS"] = 20] = "NUMBER_OF_MEMBERS";
    FieldLengths[FieldLengths["COMPANY"] = 255] = "COMPANY";
    FieldLengths[FieldLengths["TITLE"] = 128] = "TITLE";
    FieldLengths[FieldLengths["COMMENTS"] = 255] = "COMMENTS";
    FieldLengths[FieldLengths["BULK_ORDER_ADDRESS_FIELD"] = 90] = "BULK_ORDER_ADDRESS_FIELD";
})(FieldLengths = exports.FieldLengths || (exports.FieldLengths = {}));
var FieldIds;
(function (FieldIds) {
    FieldIds["FIRST_NAME"] = "first-name";
    FieldIds["LAST_NAME"] = "last-name";
    FieldIds["EMAIL"] = "email";
    FieldIds["COUNTRY_CODE"] = "country-code";
    FieldIds["COUNTRY"] = "country";
    FieldIds["STATE_CODE"] = "state-code";
    FieldIds["STATE"] = "state";
    FieldIds["RECEIVED_EMAIL"] = "receivedEmail";
    FieldIds["RECEIVED_SMS"] = "receivedSms";
    FieldIds["MEDIA_ADVERTISING"] = "mediaAdvertise";
    FieldIds["I_WORK_IN"] = "iWorkIn";
    FieldIds["TITLE"] = "title";
    FieldIds["COMPANY"] = "company";
    FieldIds["PHONE"] = "phone";
    FieldIds["COMMENTS"] = "comments";
    FieldIds["MARKETING_OPT_IN"] = "marketing-opt-in";
    FieldIds["AREA_OF_INTEREST"] = "area-of-interest";
    FieldIds["NUMBER_OF_MEMBERS"] = "number-of-members";
    FieldIds["MARKET_SEGMENT"] = "market-segment";
    FieldIds["BULK_ORDER_USE_SHIPPING_ADDRESS_FOR_BILLING"] = "bulk-order-use-shipping-address-for-billing";
    FieldIds["MEMBER_QUANTITY"] = "member-quantity";
    FieldIds["NON_MEMBER_QUANTITY"] = "non-member-quantity";
    FieldIds["TEAM_SIZE"] = "team-size";
    FieldIds["TRAINING_FOR"] = "training_for";
    FieldIds["INQUIRY_ROLE"] = "inquiry_role";
    FieldIds["TIER_PREFERENCE"] = "tier-preference";
    FieldIds["PREFERRED_CERTIFICATIONS"] = "preferred-certifications";
    FieldIds["MORE_INFORMATION_CONSENT"] = "more-info-consent";
    FieldIds["GDPR_CONSENT"] = "gdpr-consent";
    FieldIds["PRODUCT_SKU"] = "product-sku";
    FieldIds["PROSPECT_DESCRIPTION"] = "prospect-description";
    FieldIds["LOCATION"] = "location";
    FieldIds["CURRENT_STATUS"] = "current-status";
})(FieldIds = exports.FieldIds || (exports.FieldIds = {}));
var Fields;
(function (Fields) {
    Fields["FIRST_NAME"] = "firstName";
    Fields["LAST_NAME"] = "lastName";
    Fields["EMAIL"] = "email";
    Fields["COUNTRY_CODE"] = "countryCode";
    Fields["COUNTRY"] = "country";
    Fields["STATE"] = "state";
    Fields["RECEIVED_EMAIL"] = "receivedEmail";
    Fields["RECEIVED_SMS"] = "receivedSms";
    Fields["MEDIA_ADVERTISING"] = "mediaAdvertise";
    Fields["I_WORK_IN"] = "iWorkIn";
    Fields["STATE_CODE"] = "stateCode";
    Fields["TITLE"] = "title";
    Fields["COMPANY"] = "company";
    Fields["PHONE"] = "phone";
    Fields["COMMENTS"] = "comments";
    Fields["MARKETING_OPT_IN"] = "marketingOptIn";
    Fields["AREA_OF_INTEREST"] = "areaOfInterest";
    Fields["NUMBER_OF_MEMBERS"] = "numberOfMembers";
    Fields["MARKET_SEGMENT"] = "marketSegment";
    Fields["AICPAUID"] = "aicpaUid";
    Fields["VARIANT_SKU"] = "variantSku";
    Fields["MEMBER_QUANTITY"] = "memberQuantity";
    Fields["NON_MEMBER_QUANTITY"] = "nonMemberQuantity";
    Fields["MEMBER_PRICE"] = "memberPrice";
    Fields["NON_MEMBER_PRICE"] = "nonMemberPrice";
    Fields["SHIPPING_ADDRESS"] = "shippingAddress";
    Fields["BILLING_ADDRESS"] = "billingAddress";
    Fields["TEAM_SIZE"] = "teamSize";
    Fields["TIER_PREFERENCE"] = "tierPreference";
    Fields["PREFERRED_CERTIFICATIONS"] = "preferredCertifications";
    Fields["CAMPAIGN_ID"] = "campaignId";
    Fields["TRAINING_FOR"] = "trainingFor";
    Fields["INQUIRY_ROLE"] = "inquiryRole";
    Fields["RATING"] = "rating";
    Fields["UTM_CAMPAIGN"] = "utmCampaign";
    Fields["UTM_MEDIUM"] = "utmMedium";
    Fields["MORE_INFORMATION_CONSENT"] = "moreInfoConsent";
    Fields["GDPR_CONSENT"] = "gdprConsent";
    Fields["PRODUCT_SKU"] = "productSku";
    Fields["PROSPECT_DESCRIPTION"] = "prospectDescription";
    Fields["LOCATION"] = "location";
    Fields["CURRENT_STATUS"] = "currentStatus";
})(Fields = exports.Fields || (exports.Fields = {}));
var SalesForceFieldNames;
(function (SalesForceFieldNames) {
    SalesForceFieldNames["FIRST_NAME"] = "first_name";
    SalesForceFieldNames["LAST_NAME"] = "last_name";
    SalesForceFieldNames["EMAIL"] = "email";
    SalesForceFieldNames["COUNTRY_CODE"] = "country_code";
    SalesForceFieldNames["COUNTRY"] = "country";
    SalesForceFieldNames["STATE"] = "state";
    SalesForceFieldNames["RECEIVED_EMAIL"] = "SFS_LEA_TellMeMoreFlag__c";
    SalesForceFieldNames["RECEIVED_SMS"] = "SFS_LEA_GDPRConsent__c";
    SalesForceFieldNames["MEDIA_ADVERTISING"] = "MEDIA_ADVERTISING";
    SalesForceFieldNames["I_WORK_IN"] = "I_WORK_IN";
    SalesForceFieldNames["STATE_CODE"] = "state_code";
    SalesForceFieldNames["TITLE"] = "title";
    SalesForceFieldNames["COMPANY"] = "company";
    SalesForceFieldNames["PHONE"] = "phone";
    SalesForceFieldNames["COMMENTS"] = "COMMENTS";
    SalesForceFieldNames["MARKETING_OPT_IN"] = "MARKETING_OPT_IN";
    SalesForceFieldNames["AREA_OF_INTEREST"] = "AREA_OF_INTEREST";
    SalesForceFieldNames["NUMBER_OF_MEMBERS"] = "NUMBER_OF_MEMBERS";
    SalesForceFieldNames["MARKET_SEGMENT"] = "MARKET_SEGMENT";
    SalesForceFieldNames["AICPAUID"] = "AICPAUID";
    SalesForceFieldNames["VARIANT_SKU"] = "VARIANT_SKU";
    SalesForceFieldNames["MEMBER_QUANTITY"] = "MEMBER_QUANTITY";
    SalesForceFieldNames["NON_MEMBER_QUANTITY"] = "NON_MEMBER_QUANTITY";
    SalesForceFieldNames["MEMBER_PRICE"] = "MEMBER_PRICE";
    SalesForceFieldNames["NON_MEMBER_PRICE"] = "NON_MEMBER_PRICE";
    SalesForceFieldNames["SHIPPING_ADDRESS"] = "RAVE_SHIPPING_ADDRESS";
    SalesForceFieldNames["BILLING_ADDRESS"] = "RAVE_BILLING_ADDRESS";
    SalesForceFieldNames["TEAM_SIZE"] = "TEAM_SIZE";
    SalesForceFieldNames["TIER_PREFERENCE"] = "TIER_PREFERENCE";
    SalesForceFieldNames["PREFERRED_CERTIFICATIONS"] = "PREFERRED_CERTIFICATIONS";
    SalesForceFieldNames["CAMPAIGN_ID"] = "CAMPAIGN_ID";
    SalesForceFieldNames["TRAINING_FOR"] = "TRAINING_FOR";
    SalesForceFieldNames["INQUIRY_ROLE"] = "INQUIRY_ROLE";
    SalesForceFieldNames["RATING"] = "RATING";
    SalesForceFieldNames["UTM_CAMPAIGN"] = "UTM_CAMPAIGN";
    SalesForceFieldNames["UTM_MEDIUM"] = "UTM_MEDIUM";
    SalesForceFieldNames["MORE_INFORMATION_CONSENT"] = "MORE_INFORMATION_CONSENT";
    SalesForceFieldNames["GDPR_CONSENT"] = "GDPR_CONSENT";
    SalesForceFieldNames["PRODUCT_SKU"] = "SFS_LEA_ProductSKU__c";
    SalesForceFieldNames["PROSPECT_DESCRIPTION"] = "PROSPECT_DESCRIPTION";
    SalesForceFieldNames["LOCATION"] = "location";
    SalesForceFieldNames["CURRENT_STATUS"] = "SFS_LEA_CurrentStatus__c";
})(SalesForceFieldNames = exports.SalesForceFieldNames || (exports.SalesForceFieldNames = {}));
exports.SalesForceFieldMapper = {
    [Fields.FIRST_NAME]: SalesForceFieldNames.FIRST_NAME,
    [Fields.LAST_NAME]: SalesForceFieldNames.LAST_NAME,
    [Fields.EMAIL]: SalesForceFieldNames.EMAIL,
    [Fields.COUNTRY_CODE]: SalesForceFieldNames.COUNTRY_CODE,
    [Fields.COUNTRY]: SalesForceFieldNames.COUNTRY,
    [Fields.STATE]: SalesForceFieldNames.STATE,
    [Fields.I_WORK_IN]: SalesForceFieldNames.I_WORK_IN,
    [Fields.RECEIVED_EMAIL]: SalesForceFieldNames.RECEIVED_EMAIL,
    [Fields.RECEIVED_SMS]: SalesForceFieldNames.RECEIVED_SMS,
    [Fields.MEDIA_ADVERTISING]: SalesForceFieldNames.MEDIA_ADVERTISING,
    [Fields.STATE_CODE]: SalesForceFieldNames.STATE_CODE,
    [Fields.TITLE]: SalesForceFieldNames.TITLE,
    [Fields.COMPANY]: SalesForceFieldNames.COMPANY,
    [Fields.PHONE]: SalesForceFieldNames.PHONE,
    [Fields.COMMENTS]: SalesForceFieldNames.COMMENTS,
    [Fields.MARKETING_OPT_IN]: SalesForceFieldNames.MARKETING_OPT_IN,
    [Fields.AREA_OF_INTEREST]: SalesForceFieldNames.AREA_OF_INTEREST,
    [Fields.NUMBER_OF_MEMBERS]: SalesForceFieldNames.NUMBER_OF_MEMBERS,
    [Fields.MARKET_SEGMENT]: SalesForceFieldNames.MARKET_SEGMENT,
    [Fields.AICPAUID]: SalesForceFieldNames.AICPAUID,
    [Fields.VARIANT_SKU]: SalesForceFieldNames.VARIANT_SKU,
    [Fields.MEMBER_QUANTITY]: SalesForceFieldNames.MEMBER_QUANTITY,
    [Fields.NON_MEMBER_QUANTITY]: SalesForceFieldNames.NON_MEMBER_QUANTITY,
    [Fields.MEMBER_PRICE]: SalesForceFieldNames.MEMBER_PRICE,
    [Fields.NON_MEMBER_PRICE]: SalesForceFieldNames.NON_MEMBER_PRICE,
    [Fields.SHIPPING_ADDRESS]: SalesForceFieldNames.SHIPPING_ADDRESS,
    [Fields.BILLING_ADDRESS]: SalesForceFieldNames.BILLING_ADDRESS,
    [Fields.TEAM_SIZE]: SalesForceFieldNames.TEAM_SIZE,
    [Fields.TIER_PREFERENCE]: SalesForceFieldNames.TIER_PREFERENCE,
    [Fields.PREFERRED_CERTIFICATIONS]: SalesForceFieldNames.PREFERRED_CERTIFICATIONS,
    [Fields.CAMPAIGN_ID]: SalesForceFieldNames.CAMPAIGN_ID,
    [Fields.TRAINING_FOR]: SalesForceFieldNames.TRAINING_FOR,
    [Fields.INQUIRY_ROLE]: SalesForceFieldNames.INQUIRY_ROLE,
    [Fields.RATING]: SalesForceFieldNames.RATING,
    [Fields.UTM_CAMPAIGN]: SalesForceFieldNames.UTM_CAMPAIGN,
    [Fields.UTM_MEDIUM]: SalesForceFieldNames.UTM_MEDIUM,
    [Fields.MORE_INFORMATION_CONSENT]: SalesForceFieldNames.MORE_INFORMATION_CONSENT,
    [Fields.GDPR_CONSENT]: SalesForceFieldNames.GDPR_CONSENT,
    [Fields.PRODUCT_SKU]: SalesForceFieldNames.PRODUCT_SKU,
    [Fields.PROSPECT_DESCRIPTION]: SalesForceFieldNames.PROSPECT_DESCRIPTION,
    [Fields.LOCATION]: SalesForceFieldNames.LOCATION,
    [Fields.CURRENT_STATUS]: SalesForceFieldNames.CURRENT_STATUS,
};
//# sourceMappingURL=index.js.map